/**
 * Copyright 2020 ExpediaGroup. All rights reserved.
 * EXPEDIA PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

const DefaultBrandMap = Object.freeze({
  brand: 'Expedia',
  language: 'en',
  domain: 'us',
  locale: 'en_us',
  langId: '1033',
});

export default DefaultBrandMap;
